module.exports = __webpack_public_path__ + "static/media/move.d671e4e7.svg";